var CONFUSEDCMS = CONFUSEDCMS || {},
    CONFUSEDCARFINANCECALCULATORAPP = CONFUSEDCARFINANCECALCULATORAPP || {},
    Confused = Confused || {};

CONFUSEDCARFINANCECALCULATORAPP.Helper = CONFUSEDCARFINANCECALCULATORAPP.Helper || {};

(function (ns, $) {
    'use strict';

    // tokens
    ns.Tokens = {
        AMOUNT: '[AMOUNT]',
        MONTHS: '[MONTHS]',
        RATE: '[RATE]',
        MONTHLYREPAYMENT: '[MONTHLYREPAYMENT]',
        TOTALREPAYMENT: '[TOTALREPAYMENT]'
    };

    // utils functions
    ns.Utils = {
        
        // replace all
        ReplaceAll: function (target, search, replacement) {
            return target.split(search).join(replacement);
        }
    };

    // validate calculation data
    ns.validateCalculationData = function(howMuch, howLong, providerLow, providerModerate, providerHigh) {

        if (!$.isNumeric(howMuch) || !$.isNumeric(howLong) ||
            howMuch < 1000 || howMuch > 36000 ||
            howLong < 12 || howLong > 120) {
            return false;
        }

        if (!ns.validateCalculationProvider(providerLow) ||
            !ns.validateCalculationProvider(providerModerate) ||
            !ns.validateCalculationProvider(providerHigh)) {
            return false;
        }

        return true;
    };

    // validate calculation provider
    ns.validateCalculationProvider = function(provider) {

        if (provider == null || !provider.RepresentativeExample()) {
            return false;
        }

        if (!$.isNumeric(provider.Tier1000To1999Percentage()) ||
            !$.isNumeric(provider.Tier2000To2999Percentage()) ||
            !$.isNumeric(provider.Tier3000To4999Percentage()) ||
            !$.isNumeric(provider.Tier5000To7499Percentage()) ||
            !$.isNumeric(provider.Tier7500To19999Percentage()) ||
            !$.isNumeric(provider.Tier20000To36000Percentage())) {
            return false;
        }

        return true;
    };

    // obtain tier percentage
    ns.obtainTierPercentage = function (howMuch, provider) {
        var iHowMuch = parseInt(howMuch);

        if (iHowMuch >= 1000 && iHowMuch <= 1999) {
            return provider.Tier1000To1999Percentage();
        }
        else if (iHowMuch >= 2000 && iHowMuch <= 2999) {
            return provider.Tier2000To2999Percentage();
        }
        else if (iHowMuch >= 3000 && iHowMuch <= 4999) {
            return provider.Tier3000To4999Percentage();
        }
        else if (iHowMuch >= 5000 && iHowMuch <= 7499) {
            return provider.Tier5000To7499Percentage();
        }
        else if (iHowMuch >= 7500 && iHowMuch <= 19999) {
            return provider.Tier7500To19999Percentage();
        }
        else if (iHowMuch >= 20000 && iHowMuch <= 36000) {
            return provider.Tier20000To36000Percentage();
        } else {
            return null;
        }
    };

    // obtain monthly repayment
    ns.obtainMonthlyRepayment = function (tierPercentage, howMuch, howLong) {
        var fTierPercentage = parseFloat(tierPercentage);
        var iHowMuch = parseInt(howMuch);
        var iHowLong = parseInt(howLong);

        // Monthly repayment calculation as per #146738...
        var monthlyRate = Math.pow(((fTierPercentage / 100) + 1), (1 / 12)) - 1;
        var x = (1 / monthlyRate) - (1 / (monthlyRate * Math.pow((monthlyRate + 1), iHowLong)));
        var monthlyPayment = iHowMuch / x;

        return monthlyPayment;
    };

    // obtain total repayment
    ns.obtainTotalRepayment = function (monthlyRepayment, howLong) {
        var fMonthlyRepayment = parseFloat(monthlyRepayment).toFixed(2);
        var iHowLong = parseInt(howLong);

        return fMonthlyRepayment * iHowLong;
    };

    // obtain tokenized representative example
    ns.obtainTokenizedRepresentativeExample = function (tierPercentage, monthlyRepayment, totalRepayment,
                                                        howMuch, howLong, representativeExample) {

        // tokenize the representative example
        var tokenizedRepresentativeExample = ns.Utils.ReplaceAll(representativeExample, ns.Tokens.RATE, CONFUSEDCARFINANCECALCULATORAPP.Utils.NumberWithDecimalPlace(tierPercentage));

        tokenizedRepresentativeExample = ns.Utils.ReplaceAll(tokenizedRepresentativeExample, ns.Tokens.MONTHLYREPAYMENT, CONFUSEDCARFINANCECALCULATORAPP.Utils.NumberWithCommas(monthlyRepayment.toFixed(2)));
        tokenizedRepresentativeExample = ns.Utils.ReplaceAll(tokenizedRepresentativeExample, ns.Tokens.TOTALREPAYMENT, CONFUSEDCARFINANCECALCULATORAPP.Utils.NumberWithCommas(totalRepayment.toFixed(2)));
        tokenizedRepresentativeExample = ns.Utils.ReplaceAll(tokenizedRepresentativeExample, ns.Tokens.AMOUNT, CONFUSEDCARFINANCECALCULATORAPP.Utils.NumberWithCommas(howMuch));
        tokenizedRepresentativeExample = ns.Utils.ReplaceAll(tokenizedRepresentativeExample, ns.Tokens.MONTHS, howLong);

        return tokenizedRepresentativeExample;
    };



}(CONFUSEDCARFINANCECALCULATORAPP.Helper, jQuery));